export const INIT_MOBILE = `/api/v1/user/mobile/change/init`;
export const VERIFY_MOBILE = `/api/v1/user/mobile/change/verify`;
export const RESEND_VERIFY_MOBILE = `/api/user/mobile/change/resend`;
export const INIT_EMAIL = `/api/v1/user/email/change/init`;
export const VERIFY_EMAIL = `/api/v1/user/email/change/verify`;
export const RESEND_VERIFY_EMAIL = `/api/user/mobile/change/resend`;
